import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { metaSelector } from 'common/selectors/pageSelector';
import injectIntl from 'common/injectIntl';
import appConfig from '../../config';

const {
    secureCdnHost,
    cdnHost
} = appConfig;

export const RootApplicationShell = ({
    children,
    meta: { title, description, keywords, canonicalUrl, socialDescription, socialTitle, socialUrl, socialImageUrl, noIndex } = {}
}) => {
    const metaTag = [
        { 'http-equiv': 'content-type', content: 'text/html; charset=UTF-8' },
        { 'http-equiv': 'x-ua-compatible', content: 'IE=edge,chrome=1' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' },
        { name: 'title', content: title },
        { name: 'description', content: description },
        { name: 'news_keywords', content: keywords },
        { name: 'keywords', content: keywords },
        { name: 'medium', content: 'index' },
        { property: 'fb:app_id', content: '116656161708917' },
        { property: 'og:site_name', content: 'ESPN.com' },
        { property: 'og:url', content: socialUrl },
        { property: 'og:title', content: socialTitle },
        { property: 'og:description', content: socialDescription },
        { property: 'og:image', content: socialImageUrl },
        { property: 'og:type', content: 'website' },
        { name: 'twitter:site', content: 'espn' },
        { name: 'twitter:url', content: socialUrl },
        { name: 'twitter:title', content: socialTitle },
        { name: 'twitter:description', content: socialDescription },
        { name: 'twitter:image', content: socialImageUrl },
        { name: 'twitter:card', content: 'summary' },
        { name: 'twitter:app:name:iphone', content: 'ESPN' },
        { name: 'twitter:app:id:iphone', content: '317469184' },
        { name: 'twitter:app:name:googleplay', content: 'ESPN' },
        { name: 'twitter:app:id:googleplay', content: 'com.espn.score_center' }
    ];

    if (noIndex) {
        metaTag.unshift(
            { name: 'robots', content: 'noindex, nofollow' }
        );
    }

    return (
        <div className="watch-root">
            <Helmet
                title={title}
                link={[
                    { rel: 'canonical', href: canonicalUrl },
                    { rel: 'mask-icon', href: `${secureCdnHost}/prod/assets/icons/E.svg`, color: '#990000', sizes: 'any' },
                    { rel: 'shortcut icon', href: `${secureCdnHost}/favicon.ico` },
                    { rel: 'dns-prefetch', href: cdnHost },
                    { rel: 'dns-prefetch', href: secureCdnHost },
                    { rel: 'preconnect', href: cdnHost, crossorigin: '' },
                    { rel: 'preconnect', href: secureCdnHost, crossorigin: '' },
                    {
                        rel: 'apple-touch-icon',
                        href: `${secureCdnHost}/wireless/mw5/r1/images/bookmark-icons/espn_icon-57x57.min.png`
                    },
                    {
                        rel: 'apple-touch-icon-precomposed',
                        href: `${secureCdnHost}/wireless/mw5/r1/images/bookmark-icons/espn_icon-57x57.min.png`
                    },
                    {
                        rel: 'apple-touch-icon-precomposed',
                        sizes: '72x72',
                        href: `${secureCdnHost}/wireless/mw5/r1/images/bookmark-icons/espn_icon-72x72.min.png`
                    },
                    {
                        rel: 'apple-touch-icon-precomposed',
                        sizes: '114x114',
                        href: `${secureCdnHost}/wireless/mw5/r1/images/bookmark-icons/espn_icon-114x114.min.png`
                    },
                    {
                        rel: 'apple-touch-icon-precomposed',
                        sizes: '152x152',
                        href: `${secureCdnHost}/wireless/mw5/r1/images/bookmark-icons/espn_icon-152x152.min.png`
                    }
                ]}
                meta={metaTag}
                script={[{
                    type: 'application/ld+json',
                    innerHTML: `{
                        "@context": "http://schema.org",
                        "@type":    "WebSite",
                        "name":     "ESPN",
                        "url":      "http://www.espn.com/"
                    }`
                }]}
            />
            {children}
        </div>
    );
};

RootApplicationShell.propTypes = {
    children: PropTypes.node,
    meta: PropTypes.object
};

const mapStateToProps = (state, props) => ({
    meta: metaSelector(state, props)
});

export default injectIntl(connect(mapStateToProps)(RootApplicationShell));



// WEBPACK FOOTER //
// ./app/common/RootApplicationShell.js